import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { PlainContentModuleContainer } from "@silvertours/front-entities";
import { Tabs } from "../../tabs";
export var TabbedLinkLists = function(param) {
    var lists = param.lists;
    /*#__PURE__*/ return _jsx(PlainContentModuleContainer, {
        children: /*#__PURE__*/ _jsx(Tabs, {
            moduleType: "tabs",
            modules: lists.map(function(list, index) {
                var ref;
                return {
                    module: _object_spread({
                        moduleType: "linkList"
                    }, list),
                    name: ((ref = list.heading) === null || ref === void 0 ? void 0 : ref.text) || "",
                    position: index
                };
            })
        })
    });
};
